import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Check, Users } from 'lucide-react';
import axios from 'axios';
import { RVP_LIST, RVP_CONTENT } from '../data/rendezvousPedagogiques';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RvpVotePage() {
  const { session, slug, qIndex } = useParams();
  const rvp = RVP_LIST.find((r) => r.slug === slug);
  const slides = RVP_CONTENT[slug] || [];
  const qIdx = parseInt(qIndex, 10);
  // Si une slide "bienvenue" a été insérée côté présentateur, l'index est décalé de 1
  let slide = slides[qIdx];
  if ((!slide || slide.type !== 'qcm') && slides[qIdx - 1]?.type === 'qcm') slide = slides[qIdx - 1];
  const [role, setRole] = useState(localStorage.getItem('cv_voter_role') || 'eleve');
  const [voted, setVoted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { localStorage.setItem('cv_voter_role', role); }, [role]);

  if (!slide || slide.type !== 'qcm') {
    return <div className="min-h-screen bg-[#0a0a0b] text-white p-6 flex items-center justify-center"><div className="text-center">Question introuvable. Vérifie le QR code.</div></div>;
  }

  const submit = async (choice) => {
    setSubmitting(true); setError('');
    try {
      await axios.post(`${API}/poll/vote`, { session_id: session, slug, q_index: parseInt(qIndex, 10), choice, voter_role: role });
      setVoted(true);
    } catch (e) {
      setError('Erreur d\'envoi. Réessaie.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b] text-white p-5 flex flex-col" data-testid="vote-page">
      <div className="text-center mb-6">
        <div className="text-[10.5px] uppercase tracking-[0.22em] text-red-400 font-mono-spec font-bold">codevoiture.fr · {rvp?.code || 'RVP'}</div>
        <div className="mt-1 text-white/40 text-[11px] font-mono-spec">Session · {session?.toUpperCase()}</div>
      </div>

      {!voted ? (
        <>
          <div className="mb-4 flex items-center gap-2">
            <Users size={14} className="text-white/40" />
            <span className="text-white/60 text-[12px]">Tu es :</span>
            <button onClick={() => setRole('eleve')} className={`h-8 px-3 rounded-full text-[12px] ${role === 'eleve' ? 'bg-sky-500 text-black font-bold' : 'border border-white/15 text-white/70'}`}>Élève</button>
            <button onClick={() => setRole('parent')} className={`h-8 px-3 rounded-full text-[12px] ${role === 'parent' ? 'bg-amber-500 text-black font-bold' : 'border border-white/15 text-white/70'}`}>Accompagnateur</button>
          </div>

          <h1 className="font-serif-editorial text-white text-[22px] leading-tight mb-6">{slide.question}</h1>
          <div className="space-y-3 flex-1">
            {slide.options.map((opt, i) => (
              <button
                key={i}
                type="button"
                onClick={() => submit(i)}
                disabled={submitting}
                data-testid={`vote-opt-${i}`}
                className="w-full text-left rounded-xl border border-white/15 bg-white/[0.04] hover:border-red-500/60 hover:bg-red-950/30 p-4 flex items-start gap-3 disabled:opacity-40 transition"
              >
                <span className="shrink-0 w-8 h-8 rounded-full border border-white/25 text-white/70 font-mono-spec text-[13px] flex items-center justify-center">{String.fromCharCode(65 + i)}</span>
                <span className="text-[15.5px] leading-snug">{opt.text}</span>
              </button>
            ))}
          </div>
          {error && <div className="mt-3 rounded-lg border border-red-500/40 bg-red-950/30 p-3 text-red-200 text-[13px]">{error}</div>}
        </>
      ) : (
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-emerald-500/20 border border-emerald-500/50 flex items-center justify-center mb-4">
              <Check size={32} className="text-emerald-300" />
            </div>
            <div className="font-serif-editorial text-white text-[24px]">Vote enregistré !</div>
            <div className="text-white/50 text-[13px] mt-2">Regarde le vidéoprojecteur — les résultats s&apos;affichent en direct.</div>
            <button onClick={() => setVoted(false)} className="mt-6 h-10 px-4 rounded-full border border-white/15 text-white/70 text-[12px]">Voter à nouveau (si tu t&apos;es trompé)</button>
          </div>
        </div>
      )}
    </div>
  );
}
